import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Course } from '../models/course.model';
import { createSelector, select, Store } from '@ngrx/store';
import { isAdmin, isCourseAdmin, selectAllowedCourses, } from '../store/selectors';
import { Observable } from 'rxjs';
import { AppState } from '../store';
import { FormControl } from '@angular/forms';
import { CourseCardComponent } from '../course-card/course-card.component';
import { CourseFilterComponent } from '../course-filter/course-filter.component';
import { AsyncPipe, NgClass, NgFor, NgIf } from '@angular/common';

interface CoursesListData {
  isAdmin: boolean;
  isCourseAdmin: boolean;
  allowedCourses: string[];
}

const selectCoursesListData = createSelector(
  isAdmin,
  isCourseAdmin,
  selectAllowedCourses,
  (isAdmin, isCourseAdmin, allowedCourses) => {
    return {
      isAdmin,
      isCourseAdmin,
      allowedCourses,
    };
  }
);

@Component({
  selector: 'courses-list',
  templateUrl: 'courses-list.component.html',
  styleUrls: ['courses-list.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    CourseFilterComponent,
    NgFor,
    CourseCardComponent,
    NgClass,
    AsyncPipe,
  ],
})
export class CoursesListComponent implements OnInit {
  data$: Observable<CoursesListData>;

  //toggle view list and grid
  isSwapCardView: boolean = true;
  private filteredCategoryIds: string[];

  swapCardView() {
    this.isSwapCardView = !this.isSwapCardView;
    localStorage.setItem('isSwapCardView', JSON.stringify(this.isSwapCardView));
  }

  //select
  categories = new FormControl('');
  categoriesList: string[] = [
    'Extra cheese',
    'Mushroom',
    'Onion',
    'Pepperoni',
    'Sausage',
    'Tomato',
  ];

  @Input() CourseListbrandAccentColor: string;

  @Input() CourseListbrandPrimaryColor: string;

  @Input()
  courses: Course[] = [];

  filteredCourses: Course[] = null;

  @Output()
  moveDown = new EventEmitter<Course>();

  @Output()
  moveUp = new EventEmitter<Course>();

  constructor(private store: Store<AppState>) {
  }

  ngOnInit() {

    try {
      if (localStorage.getItem('isSwapCardView')) {
        this.isSwapCardView = JSON.parse(localStorage.getItem('isSwapCardView'));
      }
    }
    catch (ex) {
      this.isSwapCardView = true;
    }

    this.data$ = this.store.pipe(select(selectCoursesListData));
  }

  isCourseEditable(data: CoursesListData, course: Course) {
    return (
      data?.isAdmin ||
      (data?.isCourseAdmin && data?.allowedCourses.includes(course.id))
    );
  }

  onCourseMovedUp(course: Course) {
    this.moveUp.emit(course);
  }

  onCourseMovedDown(course: Course) {
    this.moveDown.emit(course);
  }

  onFilterPerCategoryChanged(categoryIds: string[]) {

    console.log(`Applying filtering per categories: `, categoryIds);

    if (!categoryIds?.length) {
      console.log(`No categories selected, showing all courses`);
      this.filteredCourses = this.courses;
      return;
    }

    this.filteredCategoryIds = categoryIds;

    this.filterCoursesPerCategory();

    console.log(`Filter applied: `, this.filteredCourses);

  }

  filterCoursesPerCategory() {

    const filtered = this.courses?.filter(course => {
      return course.categories?.some(categoryId => this.filteredCategoryIds?.includes(categoryId));
    });

    this.filteredCourses = filtered ? filtered : [];

    if (!this.filteredCourses?.length) {
      this.filteredCourses = null
    }
  }

}
